import React from "react";

import ArrowBack from "./components/icons/topbar/ArrowBack";

import notFound from "../assets/error/not-found.svg";

const NotFound = (props) => {
  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    gap: "3rem",
  };


  return (
    <div style={containerStyle}>
      <h2>Oops...</h2>
      <h4>Looks like you are lost.</h4>
      <img style={{ width: "25%" }} src={notFound} alt="Not Found" />
      <div>
        <div style={{ position: "absolute", top: 30, left: 10 }}>
          <a
            href="javascript:void(0)"
            onClick={() => {
              window.ReactNativeWebView.postMessage("go-back");
            }}
          >
            <ArrowBack className="" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;

